import { Dictionary } from '../models';
import { StoreItem } from './Store';

// For item with guid as key
export function buildErrorItem<T extends { guid: string }>(reason: any): StoreItem<T> {
    return {
        dictionary: {},
        isLoading: false,
        isLoaded: true,
        hasError: true,
        error: reason.data.Message || reason.message
    };
}

export function buildLoadingStoreItem<T extends { guid: string }>(): StoreItem<T> {
    return {
        dictionary: {},
        isLoading: true,
        isLoaded: false,
        hasError: false,
        error: null
    };
}

export function buildStoreItemFromDictionary<T>(dictionary: Dictionary<T>): StoreItem<T> {
    return {
        dictionary,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}

export function buildStoreItem<T extends { guid: string }>(payload: T[]): StoreItem<T> {
    const dic = {};
    payload.forEach(element => dic[element.guid] = element);
    return buildStoreItemFromDictionary(dic);
}

export function copyStoreItem<T>(dictionary: Dictionary<T>): StoreItem <T> {
    const dic = {};
    Object.keys(dictionary).forEach(k => dic[k] = dictionary[k]);
    return buildStoreItemFromDictionary(dic);
}

// For item with id as key
export function buildErrorItemForId<T extends { id: number }>(reason: any): StoreItem<T> {
    return {
        dictionary: {},
        isLoading: false,
        isLoaded: true,
        hasError: true,
        error: reason.data.Message || reason.message
    };
}

export function buildLoadingStoreItemForId<T extends { id: number }>(): StoreItem<T> {
    return {
        dictionary: {},
        isLoading: true,
        isLoaded: false,
        hasError: false,
        error: null
    };
}

export function buildStoreItemForId<T extends { id: number }>(payload: T[]): StoreItem<T> {
    const dic = {};
    payload.forEach(element => dic[element.id] = element);
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}

export function copyStoreItemForId<T>(dictionary: { [id: number]: T }): StoreItem<T> {
    const dic = {};
    Object.keys(dictionary).forEach(k => dic[k] = dictionary[k]);
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}